import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Toolbar,
  Hidden,
  IconButton,
  Link,
  makeStyles
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'src/components/Logo';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: alpha(theme.palette.background.default, 0.96),
    color: theme.palette.text.primary,
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backdropFilter: 'blur(10px)',
    zIndex: theme.zIndex.drawer + 100
  },
  toolbar: {
    height: 64,
    minHeight: 64
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'none'
    }
  }
}));

function TopBar({ onMobileNavOpen }) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  return (
    <AppBar className={classes.root}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color='inherit'
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <RouterLink to='/'>
            <Logo />
          </RouterLink>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Link
          className={classes.link}
          color='textSecondary'
          component={RouterLink}
          to='/'
          underline='none'
          variant='body2'
        >
          {t('goBack')}
        </Link>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
